export const numberWithCommas = (x) => {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const progress = () => {
  return Math.floor(Math.random() * 90) + 10 + "%";
};


export function convertSecondsToRoundedTime(seconds) {
  seconds = Math.round(seconds);
  let remainder = seconds;

  // 1 day = 86400 seconds
  const days = Math.floor(remainder / 86400);
  remainder %= 86400;

  // 1 hour = 3600 seconds
  const hours = Math.floor(remainder / 3600);
  remainder %= 3600;

  // 1 minute = 60 seconds
  const minutes = Math.floor(remainder / 60);
  const leftoverSeconds = remainder % 60;

  // --- Build Output String ---
  const parts = [];

  if (days > 0) {
    parts.push(`${days} day${days === 1 ? '' : 's'}`);
  }
  if (hours > 0) {
    parts.push(`${hours} hour${hours === 1 ? '' : 's'}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} minute${minutes === 1 ? '' : 's'}`);
  }
  if (leftoverSeconds > 0) {
    parts.push(`${leftoverSeconds} second${leftoverSeconds === 1 ? '' : 's'}`);
  }

  // If everything is zero, show "0 seconds".
  if (parts.length === 0) {
    return '0 seconds';
  }

  return parts.join(', ');
}